import api from '@/api';
import { API_BASE_URL } from '../..';
import { StockCorrectionReportRequest } from './Report.types';

const GENERATE_URL = `${API_BASE_URL}/generate/stockCorrection`;

export async function generateStockCorrectionReport(
  obj: StockCorrectionReportRequest,
) {
  const result = await (api.getReport(GENERATE_URL, obj) as unknown);
  return result as BlobPart;
}
